import { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import { useCamper } from "../../ReservationHooks/useCamper"
import NewCamperModalContent, { newCamper } from "../../../Campers/NewCamperModalContent"
import { useMutation } from "@tanstack/react-query"
import api2 from "~/api2"
import PaymentMethodModalContent from "~/components/Admin/Campers/PaymentMethodModalContent"

type Props = {
  setSlideoverOpen: (v: boolean) => void
}

export const useGuest = (props: Props) => {
  const {
    selectedReservation,
    showModal,
    selectedCamper,
    setSelectedCamper,
    showMessageModal,
    setCurrentPage,
    showNotification,
    updateLocalReservations,
  } = useContext(AdminContext)

  const camper = useCamper({
    camperId: selectedReservation?.user?.camper_id,
  })

  const newCamperInputValue = selectedCamper?.first_name || selectedCamper?.last_name || selectedCamper?.email || ""

  const onClickEditCamper = (isNewCamper: boolean = false) => {
    props.setSlideoverOpen(false)
    showModal(
      <NewCamperModalContent
        userId={selectedReservation?.user_id}
        reservationId={selectedReservation?.id}
        camper={isNewCamper ? { ...newCamper, first_name: newCamperInputValue || null } : selectedCamper || selectedReservation?.user?.camper || camper.data?.camper}
        onSuccess={(updatedCamper) => {
          setSelectedCamper(updatedCamper)
        }}
      />,
      false,
      "max-w-4xl",
      {
        closeCallback: () => {
          props.setSlideoverOpen(true)
        },
      },
    )
  }

  const { mutate: detachCamperMutation, isPending: isDetachingCamper } = useMutation({
    mutationFn: async () => {
      try {
        if (!selectedReservation?.user_id) throw "No user Id Found"
        return await api2.Users.update(selectedReservation?.user_id, {
          camper_id: null,
        })
      } catch (error) {
        console.error("Error updating reservation:", error)
        throw error
      }
    },
    onSuccess: (data) => {
      const updated = { ...selectedReservation, user: data }
      updateLocalReservations([updated])
    },
    onError: (err) =>
      showNotification({
        type: "error",
        title: "Could not detach camper",
        description: err.message,
      }),
  })

  const handleSavePaymentMethod = async () => {
    if (!camper.data?.camper) return
    props.setSlideoverOpen(false)
    showModal(<PaymentMethodModalContent camper={camper.data?.camper} />, false, "max-w-3xl", {
      closeCallback: () => {
        props.setSlideoverOpen(true)
      },
    })
  }

  const isDropdownButtonLoading = isDetachingCamper || camper.isLoading

  return {
    selectedReservation,
    camper,
    onClickEditCamper,
    showMessageModal,
    setSelectedCamper,
    setCurrentPage,
    detachCamperMutation,
    isDropdownButtonLoading,
    handleSavePaymentMethod,
  }
}
